module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5lnJB"))).then(() => parcelRequire('ikE14'));